import * as d3 from 'd3'

export default {
  methods: {

    draw_ITRs() {
      
      let Group = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, 90)`)

      let y_ = 0
      this.group.forEach(d=> {

        let items = Group
        .append('g')
        .attr('transform', `translate(0, ${y_})`)

        items
        .append('rect')
        .attr('x', 0).attr('y', 0).attr('rx', 2)
        .attr('width', 170).attr('height', (d.items.length * 20) + 20)
        .attr('fill', d.color).attr('stroke', '#bcbcbc').attr('stroke-wisth', .5).attr('opacity', d.opacity)

        items
        .append('text')
        .attr('x', 0).attr('y', -3).attr('font-size', 11).attr('fill', '#333')
        .text(d.name)


        // Header
        this.columns.filter(f=> f.name).forEach(col=> {
          items
          .append('text')
          .attr('x', col.tx).attr('y', 15)
          .attr('font-size', 10).attr('fill', '#757575').attr('text-anchor', 'end')
          .text(col.name)
        })

        // Status
        let sY = 30
        d.items.forEach(item=> {
          let stID = this.status.find(f => f.id == item)

          items
          .append('text')
          .attr('x', 47).attr('y', sY)
          .attr('font-size', 10).attr('fill', '#000').attr('text-anchor', 'end')
          .text(stID.name)

          this.columns.filter(f=> f.name).forEach(col=> {
            items
            .append('text')
            .attr('x', col.tx).attr('y', sY)
            .attr('font-size', 10).attr('fill', '#000').attr('text-anchor', 'end')
            .text(this.rawData[`${item}_${col.code}`])
            .call(this.event_Link, col, stID)
          })
          
          sY += 20
        })

        y_ += (d.items.length * 20) + 45
      })

    },
  }
}